import { getNodeIdComposer } from '@utils';
import { RootPrefix } from '../constants';

export const sidebarId = getNodeIdComposer(RootPrefix, 'sidebar');
